import React from "react";

import BatchDetail from "../../../common/BatchDetail";
import { activateColumns } from "../../../../constants/lineListColumns";
import { __getActivate } from "../../../../api/sim";

const COPY_KEYS = ["id", "batch_id", "iccid", "status", "msisdn", "last_updated"];

const ClientActivateBatch = () => (
  <BatchDetail
    title="Activate"
    apiGet={__getActivate}
    columnsFactory={activateColumns}
    copyKeys={COPY_KEYS}
    exportAction="activate"
    retryOperation="activate"
    showCheckStatus
    checkStatusOperation="activate"
    showTerminate
    terminateOperation="activate"
  />
);

export default ClientActivateBatch;
